"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getMaxYear_1 = require("./getMaxYear");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return getMaxYear_1.default; } });
//# sourceMappingURL=index.js.map